import { queryOptions } from "@tanstack/react-query";
import { getInviteByCode, getInviteDetails, listContainerInvites } from "./workspace-invites-api";

export const inviteQueries = {
  all: (containerId: string) => [containerId, "invites"] as const,
  list: (containerId: string) =>
    queryOptions({
      queryKey: [...inviteQueries.all(containerId), "list"] as const,
      queryFn: () => listContainerInvites(containerId),
      staleTime: 10_000,
    }),
  details: (inviteCode: string | undefined) =>
    queryOptions({
      queryKey: ["invite", inviteCode] as const,
      queryFn: () => (inviteCode ? getInviteDetails(inviteCode) : Promise.resolve(null)),
      enabled: Boolean(inviteCode),
      staleTime: 5_000,
    }),
  /** CR-185: the raw invite row, read when get_invite_details hides a full invite. */
  byCode: (inviteCode: string | undefined) =>
    queryOptions({
      queryKey: ["invite", inviteCode, "by-code"] as const,
      queryFn: () => (inviteCode ? getInviteByCode(inviteCode) : Promise.resolve(null)),
      enabled: Boolean(inviteCode),
      staleTime: 5_000,
    }),
};
